import { RounderUtil, IdGen } from 'utils'

const actualizarDescuento = current => {
  const numSubTotal = parseFloat(current.subTotal)

  if (current.descuentoPorcentaje && current.descuentoPorcentaje !== '') {
    const numDescuentoPorcentaje = parseFloat(current.descuentoPorcentaje)
    const numDescuentoMonto = (numSubTotal * numDescuentoPorcentaje) / 100
    const numTotal = numSubTotal - numDescuentoMonto
    current.descuentoMonto = numDescuentoMonto.toFixed(2)
    current.total = numTotal.toFixed(2)
  } else if (current.descuentoMonto && current.descuentoMonto !== '') {
    const numDescuentoMonto = parseFloat(current.descuentoMonto)
    const numTotal = numSubTotal - numDescuentoMonto
    current.descuentoPorcentaje = ''
    current.descuentoMonto = numDescuentoMonto.toFixed(2)
    current.total = numTotal.toFixed(2)
  }

  return current
}

const actualizarFila = (current, { cantidad, precio, descuentoMonto, descuentoPorcentaje, ...restPayload }) => {
  current = {
    ...current,
    ...restPayload,
    descuentoMonto,
    descuentoPorcentaje,
    cantidad,
    precio
  }

  if (cantidad && cantidad !== '' && precio && precio !== '') {
    const numCantidad = parseFloat(cantidad)
    const numPrecio = parseFloat(precio)

    const subTotal = RounderUtil.round(numCantidad * numPrecio)

    current.subTotal = subTotal
    current.total = subTotal
    current = actualizarDescuento(current)
  } else {
    current.precio = precio || ''
    current.subTotal = ''
    current.total = ''
  }

  return current
}

const commonReducer = (state, action) => {
  switch (action.type) {
    case 'agregar': {
      let newState = state
        .map(val => ({
          ...val,
          __filaActiva: false,
          __focusCantidad: false,
          __focusDescuento: false,
          __focusPrecio: false,
          esFilaBusqueda: false
        }))
        .filter(x => x._idProductoPresentacion)

      let { precio, nuevaFila, viaCodBar, ...payload } = action.payload

      // En caso de anticipo
      const nuevaFilaArr = payload.flagAnticipo
        ? []
        : [
            {
              __filaActiva: viaCodBar,
              esFilaBusqueda: true,
              _idFila: `${IdGen.newId()}-G`
            }
          ]

      let objNuevaFila = {
        ...payload,
        afectacionBase: payload.afectacion,
        __filaActiva: !viaCodBar,
        __focusCantidad: !viaCodBar,
        _idFila: IdGen.newId(),
        cantidad: payload.cantidad ? payload.cantidad : payload.flagAnticipo ? '1' : payload.flagCodigoBarra ? '1' : '',
        precio: `${precio || ''}`,
        subTotal: payload.subtotal ? payload.subtotal : payload.total ? payload.total : `0`,
        total: payload.total ? payload.total : `0`,
        descuentoMonto: payload.descuentoMonto ? payload.descuentoMonto : '',
        idAkdemic: payload.idAkdemic ? payload.idAkdemic : ''
      }

      if (payload.flagCodigoBarra) {
        objNuevaFila = actualizarFila(objNuevaFila, objNuevaFila)
      }

      return [...newState, objNuevaFila, ...nuevaFilaArr]
    }
    case 'fill': {
      const nuevaSalida = action.payload.map(x => actualizarFila(x, x))

      return [
        ...nuevaSalida,
        {
          __filaActiva: false,
          esFilaBusqueda: true,
          _idFila: `${IdGen.newId()}-G`
        }
      ]
    }
    case 'actualizar': {
      const { aplicarTodos, saltarFila, ...nuevoPayload } = action.payload
      if (aplicarTodos) {
        return state.map(val => {
          if (val.esFilaBusqueda) {
            val.__filaActiva = true
          } else {
            if (val._idFila === nuevoPayload._idFila) {
              val = actualizarFila(val, nuevoPayload)
            } else {
              const { descuentoMonto, descuentoPorcentaje } = nuevoPayload
              val = actualizarDescuento({
                ...val,
                descuentoMonto,
                descuentoPorcentaje
              })
            }

            val.__filaActiva = false
          }
          return val
        })
      } else {
        return state.map(val => {
          if (val.esFilaBusqueda) {
            val.__filaActiva = saltarFila
          } else {
            if (val._idFila === nuevoPayload._idFila) {
              let afectacion = val.afectacion
              if (nuevoPayload.flagGratuito) {
                if (val.afectacionBase === '10') {
                  afectacion = '11'
                }
              } else {
                afectacion = val.afectacionBase
              }

              val = actualizarFila(val, { ...nuevoPayload, afectacion })
            }
            val.__filaActiva = !saltarFila
          }
          return val
        })
      }
    }
    case 'actualizarComentario':
      return state.map(val => {
        if (val._idFila === action.payload._idFila) {
          val.comentario = action.payload.comentario
        }
        return val
      })
    case 'actualizarOtros':
      return state.map(val => {
        if (val._idFila === action.payload._idFila) {
          val.precioReferencia = action.payload.precioReferencia
          val.afectacion = action.payload.afectacion
        }
        return val
      })
    case 'promociones': {
      const parametrosPromociones = [...action.payload]

      // Calcular cantidad promociones disponibles
      for (let i = 0; i < parametrosPromociones.length; i++) {
        const paramProm = parametrosPromociones[i]

        const matchStatePresentaciones = state.filter(
          x => x._idProductoPresentacion === paramProm._idProductoPresentacionOrigen
        )
        const sumaCantidades = matchStatePresentaciones.reduce(
          (suma, current) => RounderUtil.round(suma + parseFloat(current.cantidad)),
          0
        )
        let cantidadDisponible = 0

        if (sumaCantidades !== 0) {
          if (paramProm._idProductoPresentacionOrigen === paramProm._idProductoPresentacionPromocion) {
            cantidadDisponible = Math.floor(sumaCantidades / (paramProm.cantidadActivacion + paramProm.factor))
          } else {
            cantidadDisponible = Math.floor(sumaCantidades / paramProm.cantidadActivacion)
          }
        }

        const unidadesRequeridas = RounderUtil.round(cantidadDisponible * paramProm.factor)

        parametrosPromociones[i].unidadesRequeridas = unidadesRequeridas
      }

      // Ejecutar promociones
      const nuevosDetalles = [...state]
      const promocionesDisponibles = parametrosPromociones.filter(x => x.unidadesRequeridas > 0)
      for (let i = 0; i < promocionesDisponibles.length; i++) {
        const promoDisp = promocionesDisponibles[i]

        let unidadesRequeridas = promoDisp.unidadesRequeridas

        for (let j = 0; j < nuevosDetalles.length; j++) {
          const det = nuevosDetalles[j]

          if (det.esFilaBusqueda) {
            continue
          }

          if (det._idProductoPresentacion !== promoDisp._idProductoPresentacionPromocion) {
            continue
          }

          if (unidadesRequeridas === 0) {
            continue
          }

          let cantidadAfectada = 0
          if (unidadesRequeridas > det.cantidad) {
            cantidadAfectada = det.cantidad
          } else {
            cantidadAfectada = unidadesRequeridas
          }

          const montoDescuentoAplicado = RounderUtil.round(
            (cantidadAfectada * parseFloat(det.precio) * promoDisp.porcentajeDescuentoPromocion) / 100
          )

          nuevosDetalles[j] = actualizarFila(det, {
            cantidad: det.cantidad,
            precio: det.precio,
            descuentoMonto: montoDescuentoAplicado
          })

          unidadesRequeridas = RounderUtil.round(unidadesRequeridas - cantidadAfectada)
        }
      }

      return nuevosDetalles
    }
    case 'aplicarTasas': {
      const tasaPorTarjeta = action.payload.tasaPorTarjeta

      const nuevosDetalles = [...state]
      for (let i = 0; i < nuevosDetalles.length; i++) {
        const nuevoDet = nuevosDetalles[i]

        const nuevaAdicion = RounderUtil.round((parseFloat(nuevoDet.precio) * tasaPorTarjeta) / 100, 4)

        nuevosDetalles[i] = actualizarFila(nuevoDet, {
          cantidad: nuevoDet.cantidad,
          precio: RounderUtil.round(parseFloat(nuevoDet.precio) + nuevaAdicion, 4)
        })
        nuevosDetalles[i].precios = []
      }

      return nuevosDetalles
    }
    case 'eliminar': {
      let nuevoEstado = state.filter(val => val._idFila !== action.payload._idFila)
      if (nuevoEstado.length === 0) {
        nuevoEstado = [
          {
            __filaActiva: false,
            esFilaBusqueda: true,
            _idFila: `${IdGen.newId()}-G`
          }
        ]
      }

      return nuevoEstado
    }
    case 'limpiar': {
      return [{ esFilaBusqueda: true, _idFila: IdGen.newId() }]
    }
    default:
      return state
  }
}

export default commonReducer
